"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _globals = require("../globals");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createDispatchers = function createDispatchers(dispatch, modules) {
  try {
    if (dispatch === undefined) {
      throw Error('Dispatch is undefined. React or TrebleGSM might not be installed.');
    }
  } catch (error) {
    console.error("".concat(_globals.trebleError, " ").concat(error));
  }

  var dispatcherMethods = {
    dispatch: function (_dispatch) {
      function dispatch(_x) {
        return _dispatch.apply(this, arguments);
      }

      dispatch.toString = function () {
        return _dispatch.toString();
      };

      return dispatch;
    }(function (payload) {
      return dispatch(payload);
    })
  };
  modules === null || modules === void 0 ? void 0 : modules.map(function (module) {
    var moduleMethods = module === null || module === void 0 ? void 0 : module.dispatchers;
    var namespaceString = module === null || module === void 0 ? void 0 : module.namespace;
    var namespaceDispatchers = module === null || module === void 0 ? void 0 : module.namespaceDispatchers;

    if (moduleMethods !== undefined) {
      var methodArray = Object.entries(moduleMethods);
      methodArray === null || methodArray === void 0 ? void 0 : methodArray.map(function (method) {
        var dispatcherKey = namespaceDispatchers ? "".concat(namespaceString, "_").concat(method[0]) : method[0];
        dispatcherMethods = _objectSpread(_objectSpread({}, dispatcherMethods), {}, _defineProperty({}, dispatcherKey, function () {
          for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
            params[_key] = arguments[_key];
          }

          return method[1].apply(method, [dispatch].concat(params));
        }));
      });
    }
  });
  return dispatcherMethods;
};

var _default = createDispatchers;
exports["default"] = _default;
module.exports = exports.default;